import { z } from 'zod';

export const EMAIL_STATUSES = ['any', 'good', 'risky', 'none'] as const;
export type EmailStatus = (typeof EMAIL_STATUSES)[number];

export const leadFiltersSchema = z.object({
  q: z.string().catch('').default(''),
  // .catch() plutôt que .optional() : une URL trafiquée retombe sur le
  // défaut au lieu de faire échouer le chargement de la route.
  emailStatus: z.enum(EMAIL_STATUSES).catch('any').default('any'),
  // Écart au plan : le test attend un BORNAGE (9 -> 5, -2 -> 0). Avec
  // .min(0).max(5) suivi de .catch(0), une valeur hors bornes retombait
  // à 0 au lieu d'être ramenée dans l'intervalle. On clampe donc.
  minRating: z.coerce.number().catch(0).default(0).transform((n) => Math.min(5, Math.max(0, n))),
  minReviews: z.coerce.number().int().min(0).catch(0).default(0),
  hasWebsite: z.coerce.boolean().catch(false).default(false),
  runId: z.string().catch('').default(''),
  country: z.string().catch('').default(''),
});

export type LeadFilters = z.infer<typeof leadFiltersSchema>;
export const DEFAULT_LEAD_FILTERS: LeadFilters = leadFiltersSchema.parse({});

export function toLeadQuery(f: LeadFilters, cursor?: string | null): Record<string, unknown> {
  const q: Record<string, unknown> = { limit: 200 };
  if (f.q) q.q = f.q;
  if (f.emailStatus !== 'any') q.email_status = f.emailStatus;
  if (f.minRating > 0) q.min_rating = f.minRating;
  if (f.minReviews > 0) q.min_reviews = f.minReviews;
  if (f.hasWebsite) q.has_website = true;
  if (f.runId) q.job_id = f.runId;
  if (f.country) q.country_code = f.country;
  if (cursor) q.after = cursor;
  return q;
}
